/**
 * MapExpandOverlay.tsx — Overlay a PANTALLA COMPLETA con el mapa grande de
 * negocios (T-020). Lo abre el botón "Expandir" del mini-mapa de zona (Home y
 * Búsqueda). Cierra con la X o con Escape. Autocontenido: gestiona su propia
 * ficha de lead (LeadSlideOver), que se muestra por encima del mapa expandido.
 */
import { useEffect, useState } from 'react'
import type { InboxItem } from '@/services/listingsService'
import BusinessMap from '@/components/cabina/BusinessMap'
import LeadSlideOver from '@/components/cabina/LeadSlideOver'

export default function MapExpandOverlay({
  open,
  items,
  onClose,
}: {
  open: boolean
  items: InboxItem[]
  onClose: () => void
}) {
  const [lead, setLead] = useState<InboxItem | null>(null)

  // Escape cierra (primero la ficha si está abierta, si no el overlay).
  useEffect(() => {
    if (!open) return
    function onKey(e: KeyboardEvent) {
      if (e.key !== 'Escape') return
      if (lead) setLead(null)
      else onClose()
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [open, lead, onClose])

  // Al cerrar el overlay, descarta la ficha que pudiera quedar abierta.
  useEffect(() => { if (!open) setLead(null) }, [open])

  if (!open) return null

  return (
    <div className="mapfull" role="dialog" aria-modal="true" aria-label="Mapa de leads a pantalla completa">
      <header className="mapfull-head">
        <div className="mapfull-title">
          <span className="ic">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M9 20l-5 2V6l5-2 6 2 5-2v16l-5 2-6-2z" /><path d="M9 4v16M15 6v16" />
            </svg>
          </span>
          <div>
            <h2>Mapa de leads</h2>
            <span className="sub">{items.length} {items.length === 1 ? 'lead' : 'leads'} · acerca para ver negocios, aleja para agrupar</span>
          </div>
        </div>
        <div className="map-legend" style={{ margin: 0 }}>
          <span className="lg high"><i />Alta oport.</span>
          <span className="lg mid"><i />Media</span>
          <span className="lg low"><i />Baja</span>
        </div>
        <button type="button" className="mapfull-close" onClick={onClose} aria-label="Cerrar mapa">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M6 6l12 12M18 6L6 18" /></svg>
        </button>
      </header>
      <div className="mapfull-body">
        <BusinessMap items={items} onOpenLead={setLead} fill />
      </div>
      <LeadSlideOver lead={lead} onClose={() => setLead(null)} />
    </div>
  )
}
